define('modules/form_editor/models/custom_month_item',['require','exports','module','./dropdown_item'],function(require, exports, module){
  "use strict";
  var DropDownItem = require("./dropdown_item");
  module.exports = DropDownItem.extend({
    defaults: {
      text: ""
    }
  });
});

